export const BannerLayout = {
  Full: 'Full',
  Default: 'Default',
  Inline: 'Inline',
  Tiny: 'Tiny',
};

export const BannerStatus = {
  Info: 'Info',
  Warning: 'Warning',
  Error: 'Error',
  Custom: 'Custom',
  Featured: 'Featured',
  Success: 'Success',
};
